<div class="toggle-visible" [style.display]="appIsHidden ? 'none' : 'block'">
    <ng-container *ngIf="{ value: state$ | async } as stateWrapper">
        <ng-container *ngIf="stateWrapper.value as state">
            <app-dev *ngIf="!production" [state]="state" [toggleKey]="'d'"></app-dev>

            <div
                [class.supervisor-mode]="
                    state.worker?.accessLevel === WorkerAccessLevel.Supervisor || state.roundState.phase === AppPhase.TableClosed
                "
                [class.online-mode]="state.configuration.tableMode === TableMode.Online"
            >
                <div #container (window:resize)="scaleContainer($event)" [style.width]="containerWidth" [style.height]="containerHeight">
                    <header>
                        <div class="header-content">
                            <div class="header-content">
                                @if (state.configuration.game && state.roundState.phase !== AppPhase.TableClosed) {
                                    <button
                                        class="icon icon-menu"
                                        [class.icon-menu-active]="menuVisible"
                                        (click)="menuVisible = !menuVisible"
                                    ></button>

                                    <div class="title">
                                        <div class="text-large" i18n>{{ state.configuration.game.displayName }}</div>
                                        <div class="text-medium">
                                            <ng-container i18n>Game ID</ng-container>: <span>{{ state.roundState.roundId ?? '-' }}</span> /
                                            <ng-container i18n>Connected players</ng-container>:
                                            <span class="monospace">{{ state.playerCount || 0 }}</span>
                                        </div>
                                    </div>
                                }
                            </div>

                            <div>
                                <div *ngIf="roundUntilChange && roundUntilChange.roundsRemaining > 0" class="notification-button">
                                    <ng-container [ngSwitch]="roundUntilChange.countdownType">
                                        <span i18n *ngSwitchCase="'TableClose'">
                                            Rounds until table closes: {{ roundUntilChange.roundsRemaining }}
                                        </span>
                                        <span i18n *ngSwitchCase="'GameChange'">
                                            Rounds until game changes: {{ roundUntilChange.roundsRemaining }}
                                        </span>
                                        <span i18n *ngSwitchCase="'CroupierLeft'">
                                            Rounds until croupier leaves: {{ roundUntilChange.roundsRemaining }}
                                        </span>
                                        <span i18n *ngSwitchDefault>Rounds remaining: {{ roundUntilChange.roundsRemaining }}</span>
                                    </ng-container>
                                </div>
                            </div>
                        </div>
                        <div class="header-content">
                            @if (
                                state.roundState.phase !== AppPhase.TableClosed ||
                                (state.worker && state.worker.accessLevel !== WorkerAccessLevel.None)
                            ) {
                                <div class="title title-align-right">
                                    <div i18n class="text-large">
                                        {{ state.worker?.name || 'Login' }}
                                    </div>
                                    <div class="text-medium monospace">{{ time$ | async }}</div>
                                </div>
                            }
                        </div>
                    </header>
                    <div class="layout">
                        <div *ngIf="menuVisible" (click)="menuVisible = false" class="menu-container">
                            <div class="menu">
                                <div class="layer layer-menu">
                                    <ul>
                                        <li>
                                            <button i18n class="icon-info" (click)="menuVisible = false; aboutDialogVisible = true">
                                                About game
                                            </button>
                                        </li>
                                        <li *ngIf="state.worker?.accessLevel === WorkerAccessLevel.Supervisor">
                                            <button i18n class="icon-history" (click)="openHistoryDialog()">Game history</button>
                                        </li>
                                        <li *ngIf="state.worker?.accessLevel === WorkerAccessLevel.Supervisor">
                                            <button i18n class="icon-register-user" (click)="openRegisterWorkerDialog()">Add user</button>
                                        </li>

                                        <!-- @if (languages.length > 0) {
                                            <li i18n class="label">Languages</li>
                                            @for (language of languages; track language.code) {
                                                <li>
                                                    <button class="no-left-bg" (click)="changeLanguage(language.code)" disabled>
                                                        <span class="unicode-icon">{{ language.flagSymbol }}</span
                                                        ><span i18n>{{ language.label }} </span>
                                                    </button>
                                                </li>
                                            }
                                        } -->
                                    </ul>
                                </div>

                                <div class="layer layer-overlay"></div>
                            </div>
                        </div>

                        <div class="main-container" [class.roulette-main]="state.configuration.tableType === TableType.RouletteTable">
                            @if (
                                state.supervisorState && state.supervisorState.subPhase === SupervisorSubPhase.GameSelection && state.games
                            ) {
                                @if (state.roundState.phase === AppPhase.TableClosed) {
                                    @if (state.games.unfinishedGame) {
                                        <app-game-selection
                                            title="Finish game"
                                            i18n-title
                                            [games]="[state.games.unfinishedGame]"
                                            (gameSelected)="selectGame($event, { isUnfinished: true })"
                                            [showBackButton]="false"
                                        />
                                    } @else {
                                        <app-game-selection
                                            [games]="state.games.availableGames"
                                            (gameSelected)="selectGame($event)"
                                            [showBackButton]="false"
                                        />
                                    }
                                } @else {
                                    <app-game-selection
                                        [games]="state.games.availableGames"
                                        [currentGameId]="state.configuration.game?.id"
                                        (gameSelected)="selectGame($event)"
                                        (backClicked)="cancelSupervisorAction()"
                                    />
                                }
                            } @else {
                                @if (
                                    state.roundState.phase === AppPhase.TableClosed &&
                                    state.worker?.accessLevel !== WorkerAccessLevel.Supervisor
                                ) {
                                    <app-supervisor-panel
                                        message="Insert supervisor RFID card to open table"
                                        i18n-message
                                        [showBackButton]="false"
                                        [tableType]="state.configuration.tableType"
                                    />
                                } @else {
                                    <app-supervisor-confirm-panels
                                        [supervisorState]="state.supervisorState"
                                        [flagsState]="state.flagsState"
                                        [currentGame]="state.configuration.game"
                                        (cancelActionClicked)="cancelSupervisorAction()"
                                        (confirmSupervisorAction)="confirmSupervisorAction()"
                                        [tableType]="state.configuration.tableType"
                                    />
                                }
                            }

                            <app-history
                                *ngIf="historyDialogVisible && state.configuration.game"
                                [currentGame]="state.configuration.game"
                                [historyGames]="historyGames"
                                [scaleFactor]="state.configuration.tableMode === TableMode.Online ? 1 - sidebarRatio : 1"
                                [loading]="loading"
                                (closeClicked)="historyDialogVisible = false"
                            ></app-history>

                            <app-register-worker
                                *ngIf="
                                    (state.supervisorState && state.supervisorState.subPhase === SupervisorSubPhase.AddingWorker) ||
                                    registerWorkerDialogVisible
                                "
                                [workerData]="workerData"
                                [tableGroups]="tableGroups"
                                (cancelSupervisorAction)="cancelRegisterWorkerDialog()"
                            ></app-register-worker>

                            @switch (state.configuration.tableType) {
                                @case (TableType.RouletteTable) {
                                    <main class="roulette-main">
                                        <app-modal *ngIf="aboutDialogVisible" (closeClicked)="aboutDialogVisible = false">
                                            <app-about
                                                [backendVersion]="state.configuration.appVersion"
                                                [frontendVersion]="version"
                                            ></app-about>
                                        </app-modal>
                                        <app-error-panel
                                            *ngIf="state.roundState?.phase === AppPhase.RoundError"
                                            [errorCode]="state.roundState.errorCode"
                                        ></app-error-panel>

                                        <div
                                            class="two-column"
                                            *ngIf="
                                                state.roundState?.phase !== AppPhase.NewRoundPreparation &&
                                                state.configuration.game &&
                                                state.roundState?.phase !== AppPhase.WaitingForCroupier
                                            "
                                        >
                                            <app-roulette-history></app-roulette-history>
                                            <app-roulette-hot-cold></app-roulette-hot-cold>
                                        </div>

                                        <div
                                            class="main-wrapper"
                                            *ngIf="
                                                state.roundState?.phase !== AppPhase.NewRoundPreparation &&
                                                state.configuration.game &&
                                                state.roundState?.phase !== AppPhase.WaitingForCroupier &&
                                                state.roundState?.phase !== AppPhase.RoundVoid
                                            "
                                        >
                                            <app-roulette-betting-timer
                                                i18n
                                                *ngIf="state?.roundState?.phase === AppPhase.BetsOpen"
                                                [initialTimeInSeconds]="
                                                    state.roundState.remainingBettingTimeInSeconds ??
                                                    state.configuration.bettingWindowInSeconds
                                                "
                                                [hurryUpTimeInSeconds]="state.configuration.hurryUpTimeInSeconds ?? 7"
                                                [timeLeftInSeconds]="
                                                    state.roundState.remainingBettingTimeInSeconds ??
                                                    state.configuration.bettingWindowInSeconds
                                                "
                                                >Bets are open
                                            </app-roulette-betting-timer>
                                            <app-roulette-betting-timer
                                                i18n
                                                *ngIf="state?.roundState?.phase === AppPhase.BetsClosed"
                                                [initialTimeInSeconds]="0"
                                                [isClosed]="true"
                                                >Bets are closed
                                            </app-roulette-betting-timer>

                                            <app-roulette-velocity-display></app-roulette-velocity-display>
                                            <app-roulette-winning-number></app-roulette-winning-number>
                                        </div>

                                        <div class="main-wrapper new-round-preparation">
                                            <app-roulette-new-round-preparation
                                                *ngIf="state.roundState?.phase === AppPhase.NewRoundPreparation"
                                            ></app-roulette-new-round-preparation>
                                            <app-waiting-for-croupier
                                                *ngIf="state.roundState?.phase === AppPhase.WaitingForCroupier"
                                                [tableType]="state.configuration.tableType"
                                            ></app-waiting-for-croupier>
                                            <app-waiting-for-players
                                                *ngIf="state.roundState?.phase === AppPhase.WaitingForPlayers"
                                            ></app-waiting-for-players>
                                            <app-round-voided *ngIf="state.roundState?.phase === AppPhase.RoundVoid"></app-round-voided>
                                        </div>
                                    </main>
                                }
                                @default {
                                    <main>
                                        <app-modal *ngIf="aboutDialogVisible" (closeClicked)="aboutDialogVisible = false">
                                            <app-about
                                                [backendVersion]="state.configuration.appVersion"
                                                [frontendVersion]="version"
                                            ></app-about>
                                        </app-modal>
                                        <app-error-panel
                                            *ngIf="state.roundState?.phase === AppPhase.RoundError"
                                            [errorCode]="state.roundState.errorCode"
                                        ></app-error-panel>
                                        <app-waiting-for-croupier
                                            *ngIf="state.roundState?.phase === AppPhase.WaitingForCroupier"
                                        ></app-waiting-for-croupier>
                                        <app-waiting-for-players
                                            *ngIf="state.roundState?.phase === AppPhase.WaitingForPlayers"
                                        ></app-waiting-for-players>
                                        <app-round-voided *ngIf="state.roundState?.phase === AppPhase.RoundVoid"></app-round-voided>
                                        <app-shoe-change *ngIf="state.roundState?.phase === AppPhase.ShoeChange"></app-shoe-change>
                                        <app-burn-cards
                                            *ngIf="state.roundState?.phase === AppPhase.CardBurn"
                                            [cardValue]="state.shoeChangeState?.card"
                                            [totalToBurnCount]="state.shoeChangeState?.totalToBurnCount ?? 0"
                                            [burnedCardsCount]="state.shoeChangeState?.burnedCount || 0"
                                        ></app-burn-cards>
                                        <app-new-round-preparation
                                            *ngIf="state.roundState?.phase === AppPhase.NewRoundPreparation"
                                        ></app-new-round-preparation>
                                        <app-bets-status
                                            *ngIf="state?.roundState?.phase === AppPhase.BetsOpen"
                                            i18n
                                            [initialTimeInSeconds]="
                                                state.roundState.remainingBettingTimeInSeconds ?? state.configuration.bettingWindowInSeconds
                                            "
                                            >Bets are open
                                        </app-bets-status>
                                        <app-bets-status
                                            *ngIf="state?.roundState?.phase === AppPhase.BetsClosed"
                                            i18n
                                            [animate]="false"
                                            [initialTimeInSeconds]="0"
                                            >Bets are closed
                                        </app-bets-status>
                                        <app-game-factory
                                            *ngIf="state.configuration.game"
                                            [gameType]="state.configuration.game.gameType"
                                            [initialData]="state.initialTableState"
                                            [tableUpdate]="state.tableUpdate"
                                            [gameResultChange]="state.gameResultChange"
                                            [appPhase]="state.roundState.phase"
                                            [dealingSubPhase]="state.roundState.subPhase"
                                        >
                                            <app-result-change
                                                result-change
                                                *ngIf="
                                                    state.supervisorState?.selectedAction === SupervisorAction.ChangeResult &&
                                                    !state.supervisorState?.changedGameResult
                                                "
                                                (resultChangeConfirmed)="confirmResultChange($event)"
                                                (resultChangeClosed)="cancelSupervisorAction()"
                                            ></app-result-change>
                                            <app-count-down
                                                count-down
                                                *ngIf="state?.roundState?.phase === AppPhase.Decision"
                                                [initialTimeInSeconds]="state.configuration.decisionTimeInSeconds ?? 0"
                                                [animate]="true"
                                            ></app-count-down>
                                        </app-game-factory>

                                        @if (dealerService.gameInProgress) {
                                            <app-cut-card *ngIf="state.shoeChangeState?.cutCardDrawn"></app-cut-card>
                                        }
                                    </main>
                                }
                            }

                            <app-notification
                                *ngIf="notification.visible"
                                [code]="notification.code"
                                [severity]="notification.severity"
                                [showCloseButton]="notification.showCloseButton"
                                (closeClicked)="notification.hide()"
                            ></app-notification>

                            <footer
                                [class.footer-fixed]="!dealerService.gameInProgress"
                                *ngIf="
                                    state.supervisorState?.selectedAction !== SupervisorAction.ChangeResult &&
                                    state.roundState?.phase !== AppPhase.WaitingForPlayers &&
                                    state.roundState?.phase !== AppPhase.RoundVoid
                                "
                            >
                                <div class="buttons-container">
                                    @if (
                                        state.supervisorState?.subPhase === SupervisorSubPhase.ActionSelection &&
                                        state.worker?.accessLevel === WorkerAccessLevel.Supervisor
                                    ) {
                                        @switch (state.configuration.tableType) {
                                            @case (TableType.RouletteTable) {
                                                <app-supervisor-actions-roulette
                                                    [supervisorActions]="state.configuration.supervisorActions"
                                                    [appPhase]="state.roundState.phase"
                                                    [flagsState]="state.flagsState"
                                                    (actionClicked)="sendSupervisorAction($event)"
                                                />
                                            }
                                            @default {
                                                <app-supervisor-actions
                                                    [supervisorActions]="state.configuration.supervisorActions"
                                                    [appPhase]="state.roundState.phase"
                                                    [flagsState]="state.flagsState"
                                                    (actionClicked)="sendSupervisorAction($event)"
                                                />
                                            }
                                        }
                                    } @else if (
                                        state.worker?.accessLevel === WorkerAccessLevel.Croupier ||
                                        state.roundState.phase === AppPhase.WaitingForCroupier
                                    ) {
                                        <button
                                            i18n
                                            [disabled]="state.roundState.phase === AppPhase.CardBurn"
                                            class="button button-medium button-neutral"
                                            (click)="callSupervisor()"
                                        >
                                            Call supervisor
                                        </button>

                                        @switch (state.configuration.tableType) {
                                            @case (TableType.RouletteTable) {
                                                <button
                                                    *ngIf="
                                                        state.configuration.tableType === TableType.RouletteTable &&
                                                        state.roundState?.phase !== AppPhase.NewRoundPreparation &&
                                                        state.roundState?.phase !== AppPhase.WaitingForCroupier &&
                                                        state.tableUpdate?.outcomes?.length
                                                    "
                                                    i18n
                                                    class="button button-medium button-accent"
                                                >
                                                    CONFIRM WINNING NUMBER
                                                </button>
                                            }
                                            @default {
                                                <button
                                                    *ngIf="state.roundState?.phase === AppPhase.ShoeChange"
                                                    i18n
                                                    class="button button-medium button-accent"
                                                    (click)="sendDealerAction(DealerAction.ShoeChanged)"
                                                >
                                                    Confirm
                                                </button>
                                            }
                                        }

                                        @if (dealerService.gameInProgress) {
                                            <!-- `false` because not yet implemented on backend -->

                                            @if (
                                                false &&
                                                (state.roundState.phase === AppPhase.RoundEnd ||
                                                    (!state.flagsState.tableClosingRequested &&
                                                        !state.flagsState.freeHandEnabled &&
                                                        !state.flagsState.gameChangingRequested))
                                            ) {
                                                <!-- Confirm result button -->
                                                <button
                                                    i18n
                                                    class="button button-medium button-accent"
                                                    [disabled]="state.roundState.phase !== AppPhase.RoundEnd"
                                                    (click)="sendDealerAction(DealerAction.CompleteRound)"
                                                >
                                                    @if (state.flagsState.tableClosingRequested) {
                                                        Confirm Result And Close Table
                                                    } @else if (state.flagsState.gameChangingRequested) {
                                                        Confirm Result And Open New Game
                                                    } @else {
                                                        Confirm Result And Start New Hand
                                                    }
                                                </button>
                                            } @else {
                                                <!-- Supervisor action confirmed message -->
                                                @if (state.flagsState.tableClosingRequested) {
                                                    <div i18n class="button button-medium button-outlined">Closing table</div>
                                                } @else if (state.flagsState.freeHandEnabled) {
                                                    <div i18n class="button button-medium button-outlined">Freeing hand</div>
                                                } @else if (state.flagsState.gameChangingRequested) {
                                                    <div i18n class="button button-medium button-outlined">
                                                        Changing game to {{ state.supervisorState?.selectedGame?.displayName }}
                                                    </div>
                                                }
                                            }
                                        }
                                    }
                                </div>
                            </footer>
                        </div>

                        <aside
                            *ngIf="
                                state.configuration.tableMode === TableMode.Online &&
                                state.roundState.phase !== AppPhase.WaitingForCroupier &&
                                state.roundState.phase !== AppPhase.TableClosed
                            "
                        >
                            <app-streaming-video
                                [videoEnabled]="!isVideoHidden"
                                [streamId]="state.configuration.videoStreamId"
                                (toggleClicked)="isVideoHidden = !isVideoHidden"
                            ></app-streaming-video>

                            <app-chat
                                [chatEnabled]="state.flagsState.chatEnabled"
                                [messages]="state.chatMessages"
                                (toggleClicked)="toggleChat(state.flagsState.chatEnabled)"
                            ></app-chat>
                        </aside>
                    </div>
                </div>
            </div>
        </ng-container>
        <div *ngIf="!stateWrapper.value">
            <h2 i18n class="title-vertical-center title-white">Connecting to table…</h2>
        </div>
    </ng-container>
</div>
